import './LeaseAssets.scss'
import { Key, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { LeaseAssetsType } from 'Models'

import { CurrencyFormatter } from 'Helpers'
import { HorizontalLoader, ModalWrapper } from 'Components'
import SearchInput from 'Components/SearchInput/SearchInput'
import { TimeConverter } from 'Helpers/TimeConverter'
import LeaseAssetService from 'Services/leaseAssetServices'
import CreateAsset from 'Pages/Frontend/Components/BlockChain/CreateAsset'
import LeaseAssetTradersCard from './LeaseAssetTradersCard/LeaseAssetTradersCard'
import InvestorsList from './Investors/InvestorsList'
import InvestorsKyc from '../InvestorsKyc/InvestorsKyc'
import TokenPool from '../../LeaseAsset/TokenPool'

// tgplus-stations/:userUuid

const LeaseAssets = () => {
  const [pageNumber] = useState(1)

  const [sortOrder, setSortOrder] = useState('DESC')

  const [status] = useState('ALL')

  const [assets, setAssets] = useState<LeaseAssetsType[]>([])

  const [loading, setLoading] = useState(false)

  const [loadingUser, setLoadingUser] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  function formatString(input: string) {
    const lowerCaseString = input.toLowerCase()

    // Remove underscores
    const formattedString = lowerCaseString.replace(/_/g, ' ')

    // capitalize status
    const capitalizedString = formattedString
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    return capitalizedString
  }

  const [tab, setTab] = useState(0)

  const [showModal, setShowModal] = useState(false)

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [show2Modal, setShow2Modal] = useState(false)

  const toggle2Modal = () => {
    setShow2Modal((prevState) => !prevState)
  }

  const getAssets = async () => {
    setLoading(true)

    await LeaseAssetService.getAllList(pageNumber, sortOrder, status).then(
      (response) => {
        setLoading(false)
        setAssets(response?.data.data.dataset)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })
      },
      (error: { response: object }) => {
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getAssets()
  }, [sortOrder, pageNumber, status])

  const urlTab = Number(new URLSearchParams(window.location.search).get('tab'))
  const activeTab = !isNaN(urlTab) ? urlTab : tab

  useEffect(() => {
    setTab(activeTab)
  }, [activeTab])

  return (
    <div className='TGPlusSubscription'>
      <div className='container mt-4'>
        <div className='card border-0 d-lg-none'>
          <div className='card-header border-0'>
            <div className='row'>
              <div className='col-12 col-md-8 my-auto'>
                <div className='title'>All Tradegrid Plus Subscription</div>
              </div>
            </div>
          </div>
        </div>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-md-9 col-lg-9  col-xl-10 my-auto'>
              <div className='head-tab'>
                {(() => {
                  return (
                    <ul className='nav nav-pills' id='pills-tab' role='tablist'>
                      <li className='nav-item' role='presentation'>
                        <Link
                          className={`nav-link h-auto ${activeTab === 0 ? 'active' : ''}`}
                          to={`${window.location.pathname}?tab=0`}
                          role='tab'
                          aria-controls='pills-home'
                          aria-selected={activeTab === 0}
                          onClick={() => setTab(0)}
                        >
                          Applications
                        </Link>
                      </li>

                      <li className='nav-item' role='presentation'>
                        <Link
                          className={`nav-link h-auto ${activeTab === 1 ? 'active' : ''}`}
                          to={`${window.location.pathname}?tab=1`}
                          role='tab'
                          aria-controls='pills-user'
                          aria-selected={activeTab === 1}
                          onClick={() => setTab(1)}
                        >
                          Assets
                        </Link>
                      </li>

                      <li className='nav-item' role='presentation'>
                        <Link
                          className={`nav-link h-auto ${activeTab === 2 ? 'active' : ''}`}
                          to={`${window.location.pathname}?tab=2`}
                          role='tab'
                          aria-controls='pills-profile'
                          aria-selected={activeTab === 2}
                          onClick={() => setTab(2)}
                        >
                          Investors
                        </Link>
                      </li>

                      <li className='nav-item' role='presentation'>
                        <Link
                          className={`nav-link h-auto ${activeTab === 3 ? 'active' : ''}`}
                          to={`${window.location.pathname}?tab=3`}
                          role='tab'
                          aria-controls='pills-profile'
                          aria-selected={activeTab === 3}
                          onClick={() => setTab(3)}
                        >
                          Investors KYC
                        </Link>
                      </li>

                      <li className='nav-item' role='presentation'>
                        <Link
                          className={`nav-link h-auto ${activeTab === 4 ? 'active' : ''}`}
                          to={`${window.location.pathname}?tab=4`}
                          role='tab'
                          aria-controls='pills-profile'
                          aria-selected={activeTab === 4}
                          onClick={() => setTab(4)}
                        >
                          Token Pool
                        </Link>
                      </li>
                    </ul>
                  )
                })()}
              </div>
            </div>
            <div className='col-md-12 col-xl-2 text-xl-end mt-3 mt-xl-0'>
              {[0, 1].includes(tab) === true && (
                <button className='btn btn-add-tgplus' onClick={toggleModal}>
                  Create New Asset
                </button>
              )}
            </div>
          </div>
          {tab === 0 && <LeaseAssetTradersCard assets={assets}></LeaseAssetTradersCard>}

          {tab === 1 && (
            <div className='card border-0'>
              <div className='card-header border-0 px-0'>
                <div className='row mt-2 d-none'>
                  <div className='col-12 col-md-8 '>
                    <SearchInput
                      onSearch={() => {
                        return
                      }}
                      placeholder={'Search Subscription No or User'}
                    ></SearchInput>
                  </div>
                  <div className='col-6 col-md-2 dropdown'>
                    <button
                      className='btn btn-filter dropdown-toggle'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <svg
                        width='17'
                        height='17'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M10.94 22.65C10.46 22.65 9.99002 22.53 9.55002 22.29C8.67002 21.8 8.14002 20.91 8.14002 19.91V14.61C8.14002 14.11 7.81002 13.36 7.50002 12.98L3.76002 9.02001C3.13002 8.39001 2.65002 7.31001 2.65002 6.50001V4.20001C2.65002 2.60001 3.86002 1.35001 5.40002 1.35001H18.6C20.12 1.35001 21.35 2.58001 21.35 4.10001V6.30001C21.35 7.35001 20.72 8.54001 20.13 9.13001L15.8 12.96C15.38 13.31 15.05 14.08 15.05 14.7V19C15.05 19.89 14.49 20.92 13.79 21.34L12.41 22.23C11.96 22.51 11.45 22.65 10.94 22.65ZM5.40002 2.85001C4.70002 2.85001 4.15002 3.44001 4.15002 4.20001V6.50001C4.15002 6.87001 4.45002 7.59001 4.83002 7.97001L8.64002 11.98C9.15002 12.61 9.65002 13.66 9.65002 14.6V19.9C9.65002 20.55 10.1 20.87 10.29 20.97C10.71 21.2 11.22 21.2 11.61 20.96L13 20.07C13.28 19.9 13.56 19.36 13.56 19V14.7C13.56 13.63 14.08 12.45 14.83 11.82L19.11 8.03001C19.45 7.69001 19.86 6.88001 19.86 6.29001V4.10001C19.86 3.41001 19.3 2.85001 18.61 2.85001H5.40002Z'
                          fill='#868484'
                        />
                        <path
                          d='M6.00004 10.75C5.86004 10.75 5.73004 10.71 5.60004 10.64C5.25004 10.42 5.14004 9.94999 5.36004 9.59999L10.29 1.69999C10.51 1.34999 10.97 1.23999 11.32 1.45999C11.67 1.67999 11.78 2.13999 11.56 2.48999L6.63004 10.39C6.49004 10.62 6.25004 10.75 6.00004 10.75Z'
                          fill='#868484'
                        />
                      </svg>
                      Filters
                    </button>
                    <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                      <div className='dropdown-item'>
                        <form action=''>
                          <div className='form-group'>
                            <label htmlFor=''>Sort List</label>
                            <select
                              id=''
                              className='form-control'
                              onChange={(e) => {
                                setSortOrder(e.target.value)
                              }}
                            >
                              <option value='DESC'>Descending Order</option>
                              <option value='ASC'>Ascending Order</option>
                            </select>
                          </div>
                          <div className='row mt-3'>
                            <div className='col-md-6'>
                              <button
                                type='button'
                                className='btn btn-reset'
                                onClick={() => setSortOrder('DESC')}
                              >
                                Reset
                              </button>
                            </div>
                            <div className='col-md-6 text-end'>
                              <button
                                type='button'
                                className='btn btn-filter'
                                onClick={() => setSortOrder('DESC')}
                              >
                                Filter
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className='col-6 col-md-2 dropdown'>
                    <button
                      className='btn btn-export dropdown-toggle'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <svg
                        width='17'
                        height='17'
                        viewBox='0 0 24 24'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                      >
                        <path
                          d='M9 11V17L11 15'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M9 17L7 15'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                        <path
                          d='M22 10H18C15 10 14 9 14 6V2L22 10Z'
                          stroke='#868484'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>{' '}
                      Export
                    </button>

                    <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                      {/* <li className='dropdown-item' onClick={()=>exportTransactions('application/pdf')}> Export as .pdf</li>  */}
                      {/* <li className='dropdown-item' onClick={()=>exportTransactions('text/csv')}> Export as .csv</li> */}
                      {/* <li className='dropdown-item' onClick={()=>exportTransactions('text/doc')}> Export as .doc </li>  */}
                    </ul>
                  </div>
                </div>
              </div>
              <div className='card-body'>
                <div className='table-responsive'>
                  <table className='table'>
                    <thead>
                      <tr>
                        <td>Asset ID</td>
                        <td>Interest Rate</td>
                        <td>Tenure</td>
                        <td>Valuation (₦)</td>
                        <td className='text-start'>Duration</td>
                        <td>Status</td>
                        <td>Date Created </td>
                        <td>Actions</td>
                        <td></td>
                      </tr>
                    </thead>
                    <tbody>
                      {loadingUser === true && assets.length === 0 && (
                        <tr>
                          <td colSpan={8} className='text-center'>
                            <HorizontalLoader></HorizontalLoader>
                          </td>
                        </tr>
                      )}

                      {assets.length > 0 &&
                        assets.map((data: LeaseAssetsType, index: Key) => (
                          <tr key={index}>
                            <td>{data.displayName}</td>
                            <td>{data.interestRatePerAnnum}</td>
                            <td>{data.investorTenureMonths}</td>
                            <td>₦{CurrencyFormatter(data.valuationInNaira)}</td>
                            <td className='text-start'>{data.leaseAgreementDurationMonths}</td>
                            <td>
                              <span className='as-status-pending'>{formatString(data.status)}</span>
                            </td>
                            <td>{TimeConverter(data.createdAt)}</td>
                            <td>
                              <Link to={`/lease-assets/details/${data.id}`}>View</Link>
                            </td>
                            <td>
                              <td className='dropdown option-dropdown'>
                                <button
                                  className='btn border-0 dropdown-toggle'
                                  data-bs-toggle='dropdown'
                                  aria-expanded='false'
                                  data-bs-popper-config='{"strategy":"fixed"}'
                                >
                                  <svg
                                    width='18'
                                    height='18'
                                    viewBox='0 0 18 18'
                                    fill='none'
                                    xmlns='http://www.w3.org/2000/svg'
                                  >
                                    <path
                                      d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                      fill='#707070'
                                    />
                                    <path
                                      d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                      fill='#707070'
                                    />
                                  </svg>
                                </button>

                                <ul className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow'>
                                  <li className='dropdown-item'>
                                    <Link to={`/lease-assets/details/${data.id}`}>
                                      View Details{' '}
                                    </Link>
                                  </li>
                                </ul>
                              </td>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {tab === 2 && <InvestorsList></InvestorsList>}
          {tab === 3 && <InvestorsKyc></InvestorsKyc>}
          {tab === 4 && <TokenPool></TokenPool>}
        </div>
      </div>

      <ModalWrapper
        showModal={showModal}
        closeModal={toggleModal}
        title='Create Asset'
        hideHeader={false}
      >
        <CreateAsset
          toggleModal={toggleModal}
          onSuccess={function (): void {
            getAssets()
          }}
        ></CreateAsset>
      </ModalWrapper>

      <ModalWrapper
        showModal={show2Modal}
        closeModal={toggle2Modal}
        title='Create Asset'
        hideHeader={false}
      >
        <CreateAsset
          toggleModal={() => {
            toggle2Modal()
            getAssets()
          }}
          onSuccess={function (): void {
            getAssets()
          }}
        ></CreateAsset>
      </ModalWrapper>
    </div>
  )
}

export default LeaseAssets
